import { createPortal } from 'react-dom';

/**
 * Portal to <body> for overlays that must stay clickable INSIDE a Radix
 * Dialog. Radix sets `pointer-events: none` on <body> while a dialog is
 * open; anything portalled to body inherits it and renders but cannot be
 * clicked. Re-enabling pointer events on the portal root is the fix.
 *
 * The wrapper is deliberately UNPOSITIONED and zero-area. pointer-events is
 * an inherited property, so this re-enables clicks for every descendant
 * while covering nothing. Do NOT give it position/inset/z-index: that turns
 * it into a full-screen click-catcher that swallows the page underneath —
 * measured on prod as a 1721x963 layer over a 240x362 dropdown menu.
 * Children bring their own positioning and stacking.
 */
export default function OverlayPortal({ children }) {
  return createPortal(
    <div style={{ pointerEvents: 'auto' }}>{children}</div>,
    document.body,
  );
}
